var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Top"),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm" }),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("img", {
              staticClass: "img-fluid",
              attrs: {
                src: require("@/assets/img/family.svg?data"),
                alt: "Bild på familj"
              }
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("img", {
              staticClass: "img-fluid img-logo-xl",
              attrs: {
                src: require("@/assets/img/logo.svg?data"),
                alt: "FHabian.nu logotyp"
              }
            }),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", { staticClass: "text-primary-fh" }, [
              _vm._v("Registrera dig")
            ]),
            _vm._v(" "),
            !_vm.iidQueryParam
              ? _c("div", { staticClass: "border--emphasize" }, [
                  _c("p", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      "\n            Det verkar som att din inbjudningslänk saknas som du ska ha fått via SMS/E-post.\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      "\n            Var vänlig kontrollera att det är via den du har fått åtkomst till denna registreringssida.\n          "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.iidQueryParam
              ? _c("div", { staticClass: "border--emphasize" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center" }, [
                    _c(
                      "strong",
                      [
                        _vm._v(
                          "\n              Notera att denna sida används enbart för registrering. "
                        ),
                        _c("br"),
                        _vm._v("\n              Inloggning sker "),
                        _c("router-link", { attrs: { to: "/login" } }, [
                          _c("u", [_vm._v("här")])
                        ]),
                        _vm._v(".\n            ")
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm" }),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "clearfix--min" }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm btn-block",
                on: {
                  click: function($event) {
                    return _vm.loginWithBankId()
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "logotype",
                  attrs: {
                    src: require("@/assets/img/bankid.svg?data"),
                    alt: "Logotyp BankID"
                  }
                }),
                _vm._v("\n          Verifiera dig med BankID\n        ")
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix--min" }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm btn-block",
                on: {
                  click: function($event) {
                    return _vm.loginWithFreja()
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "logotype",
                  attrs: {
                    src: require("@/assets/img/freja.svg?data"),
                    alt: "Logotyp Freja eID"
                  }
                }),
                _vm._v("\n          Verifiera dig med Freja eID\n        ")
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
      _vm._v(" "),
      _c("Bottom")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("Exempel på fullständig länk är:")]),
      _vm._v(" "),
      _c("pre", [
        _vm._v(
          "https://ctx.healthsolutions.se?iid=44b0f2d3-4be7-4d94-857a-001eb62a747b"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-center" }, [
      _vm._v(
        "\n            Har du fått en inbjudningslänk så har du kommit rätt. "
      ),
      _c("br"),
      _vm._v("\n            Logga in med BankID nedan.\n          ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bf3755a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf3755a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = null
// module chunks = 